export default "/images/vendor/quill/icons/code.svg?ea85b5c2863ee647d7bf543564349f8d";